import React from 'react';
import { useTranslation } from 'react-i18next';
import { Skeleton } from 'primereact/skeleton';
import EmptyPanel from '../../../../../shared/components/empty-panel/EmptyPanel';
import LineChart from '../../../../../shared/components/chart/line-chart/LineChart';

type Period = 'DAILY' | 'WEEKLY' | 'MONTHLY';

interface SourceUsageChartProps {
  matrix: (string | number)[][] | null;
  headers: string[];
  isLoading: boolean;
  activePeriod?: Period;
  onPeriodChange?: (period: Period) => void;
}

const PERIOD_OPTIONS: { value: Period; labelKey: string }[] = [
  { value: 'DAILY', labelKey: 'dailyFilter' },
  { value: 'WEEKLY', labelKey: 'weeklyFilter' },
  { value: 'MONTHLY', labelKey: 'monthlyFilter' },
];

const SourceUsageChart: React.FC<SourceUsageChartProps> = ({ matrix, headers, isLoading, activePeriod, onPeriodChange }) => {
  const { t } = useTranslation();

  return (
    <div className="stats__panel">
      <div className="page-box__title-action">
        <div className="page-box__title">{t('sourceUsageChart')}</div>
        {activePeriod && onPeriodChange && (
          <div className="filter-box">
            <div className="filter-box__tabs">
              {PERIOD_OPTIONS.map((opt) => (
                <button
                  key={opt.value}
                  type="button"
                  className={`filter-box__item ${activePeriod === opt.value ? 'filter-box__item--active' : ''}`}
                  style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                  onClick={() => onPeriodChange(opt.value)}
                >
                  {t(opt.labelKey)}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className="stats-box stats-box--line-chart">
        {isLoading ? (
          <div className="stats-box__content stats-box--chart">
            <Skeleton className="skeleton--chart">
              <span />
            </Skeleton>
          </div>
        ) : !matrix || matrix.length <= 1 ? (
          <div className="stats-box__content stats-box__content--empty">
            <EmptyPanel />
          </div>
        ) : (
          <div className="stats-box__content">
            <LineChart
              firstData={matrix}
              firstColorPalette={['#164fce', '#6794fa']}
              headers={headers}
              autoFitYAxis={true}
              minValue={0}
              legendType="FLEX_START"
              smooth={true}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SourceUsageChart;
